/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuImage } from '@neutron/react';

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 0.75rem;
  margin-bottom: 0.4rem;
`;

export const SCLogo = styled(NeuImage)`
  margin-left: -4px;
`;
